import React, { useEffect, useState } from 'react'
import { Button, Form, Row, Col } from 'react-bootstrap'
import { Nav } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';

const MenuButton = () => {
    return (
        /*<Button variant="light" className="menu-btn rounded">&#9776;</Button>*/
        //<button>&#9776;</button>
        <Nav.Item className="">
            <Nav.Link as={Link} className="text-dark menu-btn rounded" to="/">&#9776;</Nav.Link>
        </Nav.Item>
    )
}

export default MenuButton